// Continuous, seamless auto-scroll marquee for the testimonial cards.
// Duplicates the slide list once so we can loop scrollLeft back to 0 as soon as
// we've scrolled past the original list — the reset lands on an identical copy,
// so the user never sees a jump.
export default function initTestimonials() {
    const carousels = document.querySelectorAll('[data-testimonials]');

    carousels.forEach((carousel) => {
        const track = carousel.querySelector('[data-testimonials-track]');
        if (!track) return;

        const originals = Array.from(track.children);
        if (!originals.length) return;

        // Duplicate the slides so the end of set 1 meets the start of set 2.
        originals.forEach((slide) => {
            const clone = slide.cloneNode(true);
            clone.setAttribute('aria-hidden', 'true');
            track.appendChild(clone);
        });

        // Disable snap + smooth scrolling; we drive scrollLeft manually.
        track.style.scrollSnapType = 'none';
        track.style.scrollBehavior = 'auto';

        const SPEED = 40; // pixels per second
        let paused = false;
        let lastTs = 0;
        let loopWidth = 0;

        const measure = () => {
            // loopWidth = total distance of the original slide set
            loopWidth = track.scrollWidth / 2;
        };

        const step = (ts) => {
            if (!lastTs) lastTs = ts;
            const dt = (ts - lastTs) / 1000;
            lastTs = ts;

            if (!paused && loopWidth > 0) {
                let next = track.scrollLeft + SPEED * dt;
                if (next >= loopWidth) next -= loopWidth;
                track.scrollLeft = next;
            }
            requestAnimationFrame(step);
        };

        const pause = () => { paused = true; };
        const resume = () => { paused = false; lastTs = 0; };

        carousel.addEventListener('mouseenter', pause);
        carousel.addEventListener('mouseleave', resume);
        carousel.addEventListener('focusin', pause);
        carousel.addEventListener('focusout', resume);

        // Pause while offscreen to save cycles
        const io = ('IntersectionObserver' in window)
            ? new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) resume(); else pause();
                });
            }, { threshold: 0 })
            : null;
        if (io) io.observe(carousel);

        // Respect reduced motion
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        // Measure after layout / on resize
        const ready = () => { measure(); requestAnimationFrame(step); };
        if (document.readyState === 'complete') ready();
        else window.addEventListener('load', ready, { once: true });
        window.addEventListener('resize', measure);
    });
}
